import React from "react";
import PageHeader from "../PageHeader/PageHeader";
import classes from "./Project.module.css";
import bms from "../../img/BMS.png";
import ToDoList from "../../img/ToDoList.PNG";
import { FaGithub } from "react-icons/fa";
import { BsCode } from "react-icons/bs";
import { motion } from "framer-motion";

function Project() {
  return (
    <div className={classes.ProjectCont} id="projects">
      <PageHeader title={"Projects"} />
      <div className={classes.CardContainer}>
        <div className={classes.ProjectCard}>
          <div className={classes.ProjectImgDiv}>
            <img src={bms} alt="book-my-show-clone-img"></img>
          </div>
          <div className={classes.Desc}>
            <h2>BookMyShow-clone</h2>
            <div className={classes.Stack}>
              <p className={classes.React}>React</p>
              <p className={classes.Html}>HTML</p>
              <p className={classes.Css}>CSS</p>
              <p className={classes.Js}>JS</p>
              <p className={classes.Api}>TMDB API</p>
            </div>
            <small>
              BookMyShow is India's largest online movie & event ticket booking
              brand.I have tried to clone it with HTML,CSS,JS and React.
            </small>
            <div className={classes.IconsDiv}>
              <motion.div whileHover={{ scale: 1.09, x: 15 }}>
                <a
                  target="_blank"
                  href="https://github.com/kosachin/book-my-show-react-app"
                >
                  <FaGithub className={classes.Icons} size={20} color="white" />
                </a>
              </motion.div>
              <motion.div whileHover={{ scale: 1.09, x: 15 }}>
                <a
                  target="_blank"
                  href="https://bmc-clone-kosachin.vercel.app/https://github.com/kosachin/book-my-show-react-app"
                >
                  <BsCode className={classes.Icons} size={20} color="white" />
                </a>
              </motion.div>
            </div>
          </div>
        </div>
        <div className={classes.ProjectCard}>
          <div className={classes.ProjectImgDiv}>
            <img src={ToDoList} alt=""></img>
          </div>
          <div className={classes.Desc}>
            <h2>Todo List App</h2>
            <div className={classes.Stack}>
              <p className={classes.React}>React</p>
              <p className={classes.Html}>HTML</p>
              <p className={classes.Css}>CSS</p>
              <p className={classes.Js}>JS</p>
            </div>
            <small>
              A simple, elegant todos managment app to add, show and delete
              todos. Showing 3 items per page by applying pagination with page
              number and total items available.
            </small>
            <div className={classes.IconsDiv}>
              <motion.div whileHover={{ scale: 1.09, x: 15 }}>
                <a
                  target="_blank"
                  href="https://github.com/kosachin/React-Todo-App"
                >
                  <FaGithub className={classes.Icons} size={20} color="white" />
                </a>
              </motion.div>
              <motion.div whileHover={{ scale: 1.09, x: 15 }}>
                <a target="_blank" href="kosachin.github.io/react-todo-app/">
                  <BsCode className={classes.Icons} size={20} color="white" />
                </a>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project;
